import { fetchLoginInfo } from '../apis';
import { AuthModel, authModel, globalState } from '../models';
import { LoginInfo } from '../interfaces';

export const checkUserSwitchOrNot = () => {
    return fetchLoginInfo(globalState.suiteId)
        .then((newLoginInfo) => {
            compareUser(authModel, newLoginInfo);
            authModel.initConfig(newLoginInfo);
        })
        .catch((error) => {
            globalState.heartbeatCallback?.({
                type: 'error',
                error: {
                    httpCode: error.response?.status,
                    errorCode: error.response?.data?.code
                }
            });
        });
};

const compareUser = (oldLoginInfo: AuthModel, newLoginInfo: LoginInfo) => {
    const newUserId = newLoginInfo.user?._id;
    if (newUserId !== oldLoginInfo.userId) {
        // 切换了账号
        globalState.heartbeatCallback?.({
            type: 'switchUser',
            userId: newUserId
        });
        return;
    }

    const newTenantId = newLoginInfo.tenant?.id;
    if (newTenantId !== oldLoginInfo.tenantId) {
        // 切换了企业
        globalState.heartbeatCallback?.({
            type: 'switchCorp',
            tenantId: newTenantId
        });
        return;
    }
};

const clearHeartbeatTimer = () => {
    if (globalState.heartbeatInterval) {
        clearInterval(globalState.heartbeatInterval);
    }
    globalState.heartbeatInterval = null;
};

export const setHeartbeatTimer = () => {
    clearHeartbeatTimer();
    globalState.heartbeatInterval = setInterval(checkUserSwitchOrNot, 1000 * 60 * 60);
};

export const handleHeartbeatVisibilityChange = () => {
    if (document.visibilityState === 'hidden') {
        clearHeartbeatTimer();
    } else {
        checkUserSwitchOrNot().then(() => {
            setHeartbeatTimer();
        });
    }
};
